import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { OptionMenuItemComponent } from './option-menu-item';
import { OptionMenuComponent } from './option-menu.component';

@NgModule({
	imports: [CommonModule, SharedModule, RouterModule, CwpNgFrameworkModule, GenericDirectivesModule],
	declarations: [OptionMenuComponent, OptionMenuItemComponent],
	exports: [OptionMenuComponent, OptionMenuItemComponent]
})
export class OptionMenuModule { }
